import { ViewResolvedChildrenMergeHistoryComponent } from './children-deduplication/view-children-merge-tree/view-resolved-children-merge-history/view-resolved-children-merge-history.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from '../../material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { ChildrenRoutingModule } from './children-routing.module';
import { ViewChildComponent } from './view-child/view-child.component';
import { EditChildComponent } from './edit-child/edit-child.component';
import { EditChildDemographicComponent } from './edit-child/edit-child-demographic/edit-child-demographic.component';
import { EditChildDemographicGeneralComponent } from './edit-child/edit-child-demographic/edit-child-demographic-general/edit-child-demographic-general.component';
import { EditChildDemographicTerminationComponent } from './edit-child/edit-child-demographic/edit-child-demographic-termination/edit-child-demographic-termination.component';
import { EditChildDemographicParentsComponent } from './edit-child/edit-child-demographic/edit-child-demographic-parents/edit-child-demographic-parents.component';
import { EditChildDemographicIdentifiersComponent } from './edit-child/edit-child-demographic/edit-child-demographic-identifiers/edit-child-demographic-identifiers.component';

import { EditChildModalBtnComponent } from './edit-child/edit-child-modal-btn/edit-child-modal-btn.component';
import { EditChildModalComponent } from './edit-child/edit-child-modal-btn/edit-child-modal/edit-child-modal.component';
import { SearchChildrenComponent } from './search-children/search-children.component';
import { ConfirmChildDemographicSaveComponent } from './edit-child/edit-child-demographic/confirm-child-demographic-save/confirm-child-demographic-save.component';
import { EditChildEnrollmentComponent } from './edit-child/edit-child-enrollment/edit-child-enrollment.component';
import { EditChildEnrollmentModalComponent } from './edit-child/edit-child-enrollment/edit-child-enrollment-modal/edit-child-enrollment-modal.component';
import { DeleteChildEnrollmentConfirmBtnComponent } from './edit-child/edit-child-enrollment/delete-child-enrollment-confirm-btn/delete-child-enrollment-confirm-btn.component';
import { DeleteChildEnrollmentCheckComponent } from './edit-child/edit-child-enrollment/delete-child-enrollment-check/delete-child-enrollment-check.component';
import { EditChildEligibilityStatusComponent } from './edit-child/edit-child-eligibility-status/edit-child-eligibility-status.component';
import { ViewChildEligibilityCheckboxesComponent } from './edit-child/edit-child-eligibility-status/view-child-eligibility-checkboxes/view-child-eligibility-checkboxes.component';
import { ViewChildEligibilityStatusComponent } from './edit-child/edit-child-eligibility-status/view-child-eligibility-status/view-child-eligibility-status.component';
import { EditChildMoveHistoryComponent } from './edit-child/edit-child-move-history/edit-child-move-history.component';
import { NodeModule } from '../node/node.module';
import { EditChildServiceParticipationComponent } from './edit-child/edit-child-service-participation/edit-child-service-participation.component';
import { EditChildServiceParticipationModalComponent } from './edit-child/edit-child-service-participation/edit-child-service-participation-modal/edit-child-service-participation-modal.component';
import { CommunicationEventComponent } from './edit-child/communication-event/communication-event.component';
import { CommunicationTableComponent } from './edit-child/communication-event/communication-table/communication-table.component';
import { EditChildAddressInfoComponent } from './edit-child/address-info/address-info.component';
import { CourseHistoryComponent } from './edit-child/course-history/course-history.component';
import { CourseHistoryTableComponent } from './edit-child/course-history/course-history-table/course-history-table.component';
import { InaComponent } from './edit-child/ina/ina.component';
import { InaTableComponent } from './edit-child/ina/ina-table/ina-table.component';
import { SearchGroupSchoolEnrollmentsComponent } from './search-group-school-enrollments/search-group-school-enrollments.component';
import { DeleteGroupChildEnrollmentModalComponent } from './edit-child/edit-child-enrollment/delete-group-child-enrollment-modal/delete-group-child-enrollment-modal.component';
import { EditGroupChildEnrollmentModalComponent } from './edit-child/edit-child-enrollment/edit-group-child-enrollment-modal/edit-group-child-enrollment-modal.component';
import { EditINAComponent } from './edit-child/ina/edit-ina/edit-ina.component';
import { CreatedByFollowUpComponent } from './edit-child/ina/edit-ina/created-by-follow-up/created-by-follow-up.component';
import { HealthInformationComponent } from './edit-child/ina/edit-ina/health-information/health-information.component';
import { IndicatorStatusComponent } from './edit-child/ina/edit-ina/indicator-status/indicator-status.component';
import { IntervieweeComponent } from './edit-child/ina/edit-ina/interviewee/interviewee.component';
import { LearningPlanComponent } from './edit-child/ina/edit-ina/learning-plan/learning-plan.component';
import { ParentGuardianInformationComponent } from './edit-child/ina/edit-ina/parent-guardian-information/parent-guardian-information.component';
import { PersonalInformationComponent } from './edit-child/ina/edit-ina/personal-information/personal-information.component';
import { SecondaryComponent } from './edit-child/ina/edit-ina/secondary/secondary.component';
import { TableEditCommentComponent } from './edit-child/ina/edit-ina/table-edit-comment/table-edit-comment.component';
import { TableEditServiceComponent } from './edit-child/ina/edit-ina/table-edit-service/table-edit-service.component';
import { PromoteStudentSchoolEnrollmentModalComponent } from './promote-student-school-enrollment-modal/promote-student-school-enrollment-modal.component';
import { ResolvePromoteEnrollmentDetailsModalComponent } from './promote-student-school-enrollment-modal/resolve-promote-enrollment-details-modal/resolve-promote-enrollment-details-modal.component';
import { PreschoolComponent } from './edit-child/ina/edit-ina/preschool/preschool.component';
import { ElementaryComponent } from './edit-child/ina/edit-ina/elementary/elementary.component';
import { AdultEducationComponent } from './edit-child/ina/edit-ina/adult-education/adult-education.component';
import { OsyComponent } from './edit-child/ina/edit-ina/osy/osy.component';
import { GraduateStudentSchoolEnrollmentModalComponent } from './edit-child/graduate-student-school-enrollment-modal/graduate-student-school-enrollment-modal.component';
import { SearchGroupCommunicationEventsComponent } from './search-group-communication-events/search-group-communication-events.component';
import { CreateEditCommunicationEventsComponent } from './search-group-communication-events/create-edit-communication-events/create-edit-communication-events.component';
import { SearchChildCommunicationEventsComponent } from './search-group-communication-events/search-child-communication-events/search-child-communication-events.component';
import { GetStudentWithSameCommunicationEventBtnComponent } from './search-group-communication-events/search-child-communication-events/get-student-with-same-communication-event-btn/get-student-with-same-communication-event-btn.component';
import { DatePipe } from '@angular/common';
import { PastEditComponent } from './edit-child/ina/edit-ina/past-edit/past-edit.component';
import { SearchGroupServicesComponent } from './search-group-services/search-group-services.component';
import { EditChildGroupServiceParticipationComponent } from './edit-child/edit-child-group-service-participation/edit-child-group-service-participation.component';
import { ChildrenDeduplicationSummaryComponent } from './children-deduplication/children-deduplication-summary/children-deduplication-summary.component';
import { ChildrenDeduplicationUnresolvedComponent } from './children-deduplication/children-deduplication-unresolved/children-deduplication-unresolved.component';
import { ChildrenDeduplicationResolvedComponent } from './children-deduplication/children-deduplication-resolved/children-deduplication-resolved.component';
import { ChildrenDeduplicationRegionComponent } from './children-deduplication/children-deduplication-region/children-deduplication-region.component';
import { ChildrenDeduplicationCompareBtnComponent } from './children-deduplication/children-deduplication-compare-btn/children-deduplication-compare-btn.component';
import { ChildrenDeduplicationCompareModalComponent } from './children-deduplication/children-deduplication-compare-btn/children-deduplication-compare-modal/children-deduplication-compare-modal.component';
import { MergeChildrenBtnComponent } from './children-deduplication/merge-children-btn/merge-children-btn.component';
import { MergeChildrenModalComponent } from './children-deduplication/merge-children-btn/merge-children-modal/merge-children-modal.component';
import { ViewChildMoveHistoryComponent } from './view-child/view-child-move-history/view-child-move-history.component';
import { ViewChildAddressInfoComponent } from './view-child/view-child-address-info/view-child-address-info.component';
import { ViewChildCommunicationEventComponent } from './view-child/view-child-communication-event/view-child-communication-event.component';
import { ViewChildCourseHistoryComponent } from './view-child/view-child-course-history/view-child-course-history.component';
import { ViewChildDemographicComponent } from './view-child/view-child-demographic/view-child-demographic.component';
import { ViewChildEnrollmentComponent } from './view-child/view-child-enrollment/view-child-enrollment.component';
import { ViewChildInaComponent } from './view-child/view-child-ina/view-child-ina.component';
import { ViewChildServiceParticipationComponent } from './view-child/view-child-service-participation/view-child-service-participation.component';
import { ViewChildDemographicGeneralComponent } from './view-child/view-child-demographic/view-child-demographic-general/view-child-demographic-general.component';
import { ViewChildDemographicIdentifiersComponent } from './view-child/view-child-demographic/view-child-demographic-identifiers/view-child-demographic-identifiers.component';
import { ViewChildDemographicParentsComponent } from './view-child/view-child-demographic/view-child-demographic-parents/view-child-demographic-parents.component';
import { ViewChildDemographicTerminationComponent } from './view-child/view-child-demographic/view-child-demographic-termination/view-child-demographic-termination.component';
import { PartyModule } from '../party/party.module';
import { ChildrenDeduplicationMergeComponent } from './children-deduplication/children-deduplication-merge/children-deduplication-merge.component';
import { ViewChildrenMergeTreeComponent } from './children-deduplication/view-children-merge-tree/view-children-merge-tree.component';
import { ViewChildrenMergeTreeBranchesComponent } from './children-deduplication/view-children-merge-tree/view-children-merge-tree-branches/view-children-merge-tree-branches.component';
import { ViewChildrenMergeTreeBtnComponent } from './children-deduplication/view-children-merge-tree/view-children-merge-tree-btn/view-children-merge-tree-btn.component';
import { ResolveSSIDComponent } from './resolve-ssid/resolve-ssid.component';
import { UnresolvedComponent } from './resolve-ssid/unresolved/unresolved.component';
import { resolve } from 'dns';
import { ResolvedComponent } from './resolve-ssid/resolved/resolved.component';
import { ResolveProvisionalSchoolModalComponent } from './edit-child/edit-child-enrollment/resolve-provisional-school-modal/resolve-provisional-school-modal.component';
import { ViewChildSsidHistoryBtnComponent } from './view-child/view-child-demographic/view-child-ssid-history-btn/view-child-ssid-history-btn.component';
import { ViewChildSsidHistoryModalComponent } from './view-child/view-child-demographic/view-child-ssid-history-btn/view-child-ssid-history-modal/view-child-ssid-history-modal.component';
import { ResolvedMatchTaskComponent } from './resolve-ssid/resolved-match-task/resolved-match-task.component';
import { UnresolvedMatchTaskComponent } from './resolve-ssid/unresolved/unresolved-match-task/unresolved-match-task.component';
import { EditProvisionalSchoolInformationComponent } from './edit-child/edit-child-enrollment/resolve-provisional-school-modal/edit-provisional-school-information/edit-provisional-school-information.component';

@NgModule({
    declarations: [
        ViewChildComponent,
        EditChildComponent,
        EditChildDemographicComponent,
        EditChildDemographicGeneralComponent,
        EditChildDemographicTerminationComponent,
        EditChildDemographicParentsComponent,
        EditChildDemographicIdentifiersComponent,
        EditChildModalBtnComponent,
        EditChildModalComponent,
        SearchChildrenComponent,
        ConfirmChildDemographicSaveComponent,
        EditChildAddressInfoComponent,
        EditChildEnrollmentComponent,
        EditChildEnrollmentModalComponent,
        EditGroupChildEnrollmentModalComponent,
        DeleteGroupChildEnrollmentModalComponent,
        DeleteChildEnrollmentConfirmBtnComponent,
        DeleteChildEnrollmentCheckComponent,
        EditChildEligibilityStatusComponent,
        ViewChildEligibilityCheckboxesComponent,
        ViewChildEligibilityStatusComponent,
        ViewChildAddressInfoComponent,
        ViewChildCommunicationEventComponent,
        ViewChildCourseHistoryComponent,
        ViewChildDemographicComponent,
        ViewChildDemographicGeneralComponent,
        ViewChildDemographicIdentifiersComponent,
        ViewChildDemographicParentsComponent,
        ViewChildDemographicTerminationComponent,
        ViewChildEnrollmentComponent,
        ViewChildInaComponent,
        ViewChildMoveHistoryComponent,
        ViewChildServiceParticipationComponent,
        EditChildMoveHistoryComponent,
        EditChildServiceParticipationComponent,
        EditChildServiceParticipationComponent,
        EditChildServiceParticipationModalComponent,
        CommunicationEventComponent,
        CommunicationTableComponent,
        CourseHistoryComponent,
        CourseHistoryTableComponent,
        InaComponent,
        InaTableComponent,
        SearchGroupSchoolEnrollmentsComponent,
        EditINAComponent,
        CreatedByFollowUpComponent,
        HealthInformationComponent,
        IndicatorStatusComponent,
        IntervieweeComponent,
        LearningPlanComponent,
        ParentGuardianInformationComponent,
        PersonalInformationComponent,
        SecondaryComponent,
        TableEditCommentComponent,
        TableEditServiceComponent,
        PromoteStudentSchoolEnrollmentModalComponent,
        ResolvePromoteEnrollmentDetailsModalComponent,
        GraduateStudentSchoolEnrollmentModalComponent,
        SearchGroupCommunicationEventsComponent,
        CreateEditCommunicationEventsComponent,
        SearchChildCommunicationEventsComponent,
        GetStudentWithSameCommunicationEventBtnComponent,
        PreschoolComponent,
        ElementaryComponent,
        AdultEducationComponent,
        OsyComponent,
        GraduateStudentSchoolEnrollmentModalComponent,
        PastEditComponent,
        SearchGroupServicesComponent,
        EditChildGroupServiceParticipationComponent,
        ChildrenDeduplicationSummaryComponent,
        ChildrenDeduplicationUnresolvedComponent,
        ChildrenDeduplicationResolvedComponent,
        ChildrenDeduplicationRegionComponent,
        ChildrenDeduplicationCompareBtnComponent,
        ChildrenDeduplicationCompareModalComponent,
        MergeChildrenBtnComponent,
        MergeChildrenModalComponent,
        ChildrenDeduplicationMergeComponent,
        ViewChildrenMergeTreeComponent,
        ViewChildrenMergeTreeBranchesComponent,
        ViewChildrenMergeTreeBtnComponent,
        ViewResolvedChildrenMergeHistoryComponent,
        ResolveSSIDComponent,
        UnresolvedComponent,
        ResolvedComponent,
        ResolveProvisionalSchoolModalComponent,
        ViewChildSsidHistoryBtnComponent,
        ViewChildSsidHistoryModalComponent,
        ResolvedMatchTaskComponent,
        UnresolvedMatchTaskComponent,
        EditProvisionalSchoolInformationComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        CommonComponentsModule,
        ChildrenRoutingModule,
        NodeModule,
        PartyModule
    ],
    exports: [EditChildModalBtnComponent]
})
export class ChildrenModule {}
